<template>
  <main
    class="app-page"
    :class="{ 'app-page--full-width': fullWidth }"
    :aria-labelledby="labelledby || undefined"
  >
    <div class="app-page__inner">
      <slot />
    </div>
  </main>
</template>

<script>
export default {
  name: 'AppPage',
  props: {
    labelledby: {
      type: String,
      default: ''
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-page {
  min-height: var(--sid-state-min-height);
  margin: 0;
  padding: var(--sid-page-gutter-desktop);
  background: var(--sid-color-surface-canvas);
}

.app-page__inner {
  width: 100%;
  max-width: var(--sid-content-max-width);
  margin: 0 auto;
}

.app-page--full-width .app-page__inner {
  max-width: none;
}

@media (max-width: 1023px) {
  .app-page {
    padding: var(--sid-page-gutter-tablet);
  }
}

@media (max-width: 599px) {
  .app-page {
    padding: var(--sid-page-gutter-mobile);
  }
}
</style>
